<style lang="scss" src='./StoreAddresses.scss' scoped></style>
<template src="./StoreAddresses.html"></template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations,
    mapGetters
  } from "vuex";
  import moment from 'moment';
  import router from '@/router';
  export default {
    name: "StoreAddresses",
    components: {},
    data() {

      return {
        selected: null,
        tabIndex: 0,
        showError: false,
        loading: false,
      };
    },
    computed: {
      ...mapGetters('CartStore', ['getPickupMethods']),
      ...mapState('Main',['storeList', 'currentStore']),
    },

    methods: {
      ...mapActions('CartStore', ['fnApiSetDeliveryMethod']),
      ...mapMutations('Main',['setCurrentStore']),
      
      fnGetDate(date) {
        return this.F_capitalizeAllFirst(this.F_formatDeliveryDate(date));
      },
      fnGetDateTime(dateTime) {
        return moment(dateTime, 'hh:mm:ss').format('hh:mm A');
      },

      async fnValidate() {
        if (this.selected != null) {
          this.showError = false;
          let tempBody = {
            type: 'PICKUP',
            date: this.selected.pickupDate.date,
            pick_up_time_id: this.selected.time.pick_up_time_id
          };
          this.loading = true;
          let result = await this.fnApiSetDeliveryMethod(tempBody);
          if(result){
            if(this.setCurrentStore.store_id != result.store_id){
              let store = this.storeList.find(x => x.store_id == result.store_id);
              if(store){
                this.setCurrentStore(store);
              }
            }

            if (tempBody.type == 'DELIVERY') {
              router.push('/payment/schedule');
            } else {
              router.push('/payment/summary');
            }
          }
          this.loading = false;
        } else {
          this.showError = true;
        }
      }
    },

    beforeCreate() {},

    created() {},

      mounted() {  },
    beforeDestroy() {

    },
  };

</script>
